import {combineReducers} from 'redux';

import {VisibilitySliceFor} from '../../../../store/VisibilitySliceFor';
import {SelectionSliceFor} from '../../../../store/SelectionSliceFor';
import config from "../config";

const entityKey = config.entityKey;

const visibilitySlice = VisibilitySliceFor(entityKey);
const selectionSlice = SelectionSliceFor(entityKey);

export const {
    setPage,
    incrementPage,
    decrementPage,
    setPageSize,
    resetPageSize,
    setKeyword,
    clearKeyword,
    show,
    hide,
    toggleVisibility,
    setTableColumns,
    addTableColumn,
} = visibilitySlice.actions;

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} =
    selectionSlice.actions;

// FNP-945: the `records` sub-reducer is gone - records live in React Query.
export const AccountsReducer = combineReducers({
                                                   
                                                   selection: selectionSlice.reducer,
                                                   visibility: visibilitySlice.reducer,
                                               });

